<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="['group-button', getSelectedDEV && 'dev-selected-component']">
    <v-btn
      v-bind="item.attributes"
      :disabled="item.readonly"
      v-for="(item, index) in filteredItems"
      :key="index"
      v-tooltip.bottom="{ content: item.tooltip, classes: item.tooltipColorClass }"
      :name="item.name"
      :id="setId(item.id)"
      :loading="actionName === item.name && loading"
      @click="execute(item)"
    >
      <v-icon v-if="item.attributesIcon.icon && !item.attributesIcon.right" v-bind="item.attributesIcon" class="mr-1">{{
        item.attributesIcon.icon
      }}</v-icon>
      {{ item.label }}
      <v-icon v-if="item.attributesIcon.icon && item.attributesIcon.right" v-bind="item.attributesIcon" class="ml-1">{{
        item.attributesIcon.icon
      }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import inputEventsMixin from '@/mixins/input-events-mixin';
import store from '@/store';
import * as HANDLERS from '@/helpers/types/handlers';

export default {
  mixins: [abstractField, devComponentMixin, inputEventsMixin],

  data: () => ({
    loading: false,
    actionName: '',
    filteredItems: []
  }),

  mounted() {
    this.filteredItems = this.schema.items.filter(item => item.visible);
  },

  watch: {
    schema: {
      handler(newValue, oldValue) {
        this.filteredItems = this.schema.items.filter(item => item.visible);
      },
      deep: true
    }
  },

  events: {
    [HANDLERS.INIT_LOADING]: 'initLoading',
    [HANDLERS.FINISH_LOADING]: 'finishLoading',
    [HANDLERS.HIDE_ACTION]: 'hideAction',
    [HANDLERS.SHOW_ACTIONS]: 'showAllActions'
  },

  methods: {
    hideAction({ action, mode, page }) {
      if (this.formOptions.mode !== mode || this.formOptions.page !== page || !this.filteredItems) return;

      let element = this.schema.items.find(a => a.name === action);

      if (element) element.visible = false;
    },

    showAllActions({ mode, page }) {
      if (this.formOptions.mode !== mode || this.formOptions.page !== page || !this.filteredItems) return;

      for (let action of this.schema.items) {
        if ('hidden' in action) return;
        action.visible = true;
      }
    },

    setId(field) {
      return this.formOptions.mode === 'list' ? `${field}_${this.formOptions.index}` : field;
    },

    execute(action) {
      action.mode = this.formOptions.mode;

      this.$emit(HANDLERS.EXECUTE_ACTION, { action, origin: this.formOptions.page });
    },

    initLoading(action) {
      this.actionName = action.name;

      const _vm = this;

      this.schema.items.map(function(item) {
        if (item.name === action.name) {
          _vm.loading = true;

          return;
        }
      });
    },

    finishLoading() {
      this.actionName = '';
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.group-button {
  button {
    margin-right: 10px;

    &:last-child {
      margin-right: 0px;
    }
  }
}
</style>
